import { useParams } from "react-router-dom";
import { PropertyDetailsCard } from "./section-components/PropertyDetailsCard";
import React, { useEffect, useState } from "react";
import { getAllProperties, getPropertyById } from "../services/propertyService";
import { Box, Grid2 } from "@mui/material";
import Product from "./section-components/product";
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/Sales Main Photo.jpeg';
import bgIndiaImage from '../assets/img/newimgaes/Sales India1.jpeg';
import lettingImage from '../assets/img/newimgaes/Lettings Main Photo.jpeg';
import Toast from "../components/Toast"

const PropertyDetails = () => {
    const id = useParams();
    const [property, setProperty] = useState({});
    const [properties, setProperties] = useState([]);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    // Determine property type from property data
    const determinePropertyType = (propertyData) => {
        // Check explicit property type fields first
        const explicitType = propertyData?.propertyType || propertyData?.type || propertyData?.propertyCategory;
        if (explicitType) return explicitType.toLowerCase();
        
        // Check if area unit indicates agricultural property
        const areaUnit = propertyData?.area?.unit?.toLowerCase();
        if (areaUnit === 'hectares' || areaUnit === 'acres') return 'agricultural';
        
        // Default fallback
        return 'residential';
    };

    useEffect(() => {
        getPropertyById(id.id)
            .then((res) => {
                console.log(res, 'response');
                setProperty(res);
                // setToastMessage("Property details loaded successfully!");
                // setToastOpen(true);
            })
            .catch((error) => {
                console.error('Error loading property details:', error);
                setToastMessage("Failed to load property details.");
                setToastOpen(true);
            });
    }, [id]);

    return (
        <>
            <Pageheader headertitle="Details" bgImage={property.propertyStatus === 'For Rent' ? lettingImage : property.country === 'India' ? bgIndiaImage : bgImage} />
            <PropertyDetailsCard property={property} propertyType={determinePropertyType(property)} />
            {/* Toast message component */}
            <Toast open={toastOpen} severity="error" message={toastMessage} onClose={() => setToastOpen(false)} />
        </>
    );
}

export default PropertyDetails;
